import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import RowClick from '../../../common/RowClick';
import Const from './Const';
import RankingConst from '../Const';
import {
  REDUCER_NAME,
  intervalFetchAllScore,
  loadMoreAllScore,
  changeIndustryTableDropDown,
  changeAllScoreSortState,
  defaultAllScoreSortState,
} from '../reducer';
import STTable from './../../../common/mixTable/STTable';
import { I18n } from 'react-redux-i18n';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';

class FiinTradeAllScoreTable extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      page: 1,
      pageSize: Const.maxRowData,
      rankingId: 1,
      isHover: false,
      lstDataIndustry: [],
      resetScrollIndex: 0,
    };
    this.state = this.initialState;
  }

  componentDidMount() {
    const { intervalFetchAllScore, listIndustryByIcbLevel } = this.props;
    intervalFetchAllScore(true, {
      ComGroupCode: this.getComGroupCode(),
    });
    this.setStateListDropdown(listIndustryByIcbLevel);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      intervalFetchAllScore,
      listIndustryByIcbLevel,
      currentTabAllScore,
      sortState,
      currentSelectedIndustryTable,
    } = this.props;
    const isSortStateChanged =
      sortState !== prevProps.sortState &&
      Const.fetchDataSortKeys.includes(Object.keys(sortState)[0]);
    const isChangeIndustry =
      currentSelectedIndustryTable !== prevProps.currentSelectedIndustryTable;
    if (
      prevProps.i18n.locale !== this.props.i18n.locale ||
      isSortStateChanged ||
      isChangeIndustry
    ) {
      intervalFetchAllScore(true, {
        ComGroupCode: this.getComGroupCode(),
      });
    }
    const lstPrevListIndustry = prevProps
      ? prevProps.listIndustryByIcbLevel
      : [];
    if (!_.isEqual(listIndustryByIcbLevel, lstPrevListIndustry)) {
      this.setStateListDropdown(listIndustryByIcbLevel);
    }

    if (currentTabAllScore !== prevProps.currentTabAllScore) {
      this.setState({
        resetScrollIndex: this.state.resetScrollIndex + 1,
      });
      intervalFetchAllScore(true, {
        ComGroupCode: this.getComGroupCode(),
      });
    }
  }

  setStateListDropdown = listIndustryByIcbLevel => {
    let lstData = !_.isEmpty(listIndustryByIcbLevel)
      ? _.orderBy(listIndustryByIcbLevel[3], ['icbName'], ['asc'])
      : [];
    const itemAllIndustries = {
      ...Const.itemAllIndustries,
      icbName: I18n.t('strategy.AllIndustries'),
    };
    lstData = _.concat(itemAllIndustries, lstData);
    this.setState({
      lstDataIndustry: lstData,
    });
  };

  getComGroupCode = () => {
    const { currentTabAllScore } = this.props;
    const mapComGroupCode = {
      [RankingConst.listTabFilterAllScore.all]: '',
      [RankingConst.listTabFilterAllScore.HOSE]: 'VNIndex',
      [RankingConst.listTabFilterAllScore.HNX]: 'HnxIndex',
    };

    return mapComGroupCode[currentTabAllScore];
  };

  getDataFromRedux = state => {
    return state[REDUCER_NAME].listAllScoreByTicker;
  };

  handleScroll = e => {
    const { page } = this.state;
    const { totalPage, ids } = this.props;
    if (page === totalPage) return;
    if (ids.length < Const.maxRowData) return;
    const bottom =
      e.target.scrollTop !== 0 &&
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
        e.target.clientHeight;
    if (bottom) {
      this.loadMoreActive();
    }
  };

  loadMoreActive = () => {
    const {
      loadMoreAllScore,
      listAllScoreLoadMore,
      listAllScoreByTicker,
      totalPage,
      industryId,
      isLoading,
      scoreId,
      page,
    } = this.props;

    if (page === totalPage || isLoading) return;
    let pageCurrent = parseInt(page);
    this.setState(() => {
      loadMoreAllScore({
        Page:
          _.isEmpty(listAllScoreLoadMore) &&
          !_.isEmpty(listAllScoreByTicker) &&
          pageCurrent > 1
            ? pageCurrent
            : pageCurrent + 1,
        Code: industryId,
        ComGroupCode: this.getComGroupCode(),
        scoreId,
      });
    });
  };

  onSort = sortState => {
    const { changeAllScoreSortState } = this.props;
    if (!Object.keys(sortState).length) {
      changeAllScoreSortState(defaultAllScoreSortState);
      return;
    }
    changeAllScoreSortState(sortState);
  };

  renderTable() {
    const {
      isLoading,
      ids,
      changeIdHover,
      organCodeHover,
      listConfigTable,
      changeIndustryTableDropDown,
      currentSelectedIndustryTable,
    } = this.props;
    const { lstDataIndustry, resetScrollIndex } = this.state;
    let idHover = organCodeHover;
    if (!ids.includes(organCodeHover) && organCodeHover !== '') {
      idHover = '';
    }

    return (
      <RowClick>
        {onRowClick => (
          <STTable
            onSort={this.onSort}
            onRowClick={onRowClick}
            resetScrollIndex={resetScrollIndex}
            ids={ids}
            isLoading={isLoading}
            getDataFromRedux={this.getDataFromRedux}
            schemaKey={'stRanking.fiinTradeAllScoreHeader'}
            listColumn={listConfigTable}
            isHeaderTable={true}
            titleHeaderTable={I18n.t('stRanking.titleTableAllScore')}
            colorLeft="#1455c0"
            colorRight="#5eedfd"
            isHighlight={true}
            idHover={idHover}
            changeIdHover={changeIdHover}
            currentSelectedIndustryTable={currentSelectedIndustryTable}
            listIndustry={lstDataIndustry}
            handleScroll={this.handleScroll}
            changeIndustryTableDropDown={changeIndustryTableDropDown}
          />
        )}
      </RowClick>
    );
  }
  render() {
    return this.renderTable();
  }
}
const mapStateToProps = state => ({
  i18n: state.i18n,
  ids: state[REDUCER_NAME].listTickerAllScore,
  currentSelectedIndustryTable:
    state[REDUCER_NAME].currentSelectedIndustryTable,
  listAllScoreByTicker: state[REDUCER_NAME].listAllScoreByTicker,
  listAllScoreLoadMore: state[REDUCER_NAME].listAllScoreLoadMore,
  listIndustryByIcbLevel: state[COMMON_REDUCER_NAME].listIndustryByIcbLevel,
  industryId: state[REDUCER_NAME].industryId,
  organCodeHover: state[REDUCER_NAME].organCodeHover,
  organCode: state[REDUCER_NAME].organCode,
  isLoading: state[REDUCER_NAME].isLoading,
  totalPage: state[REDUCER_NAME].totalPage,
  firstPage: state[REDUCER_NAME].firstPage,
  page: state[REDUCER_NAME].page,
  scoreId: state[REDUCER_NAME].scoreId,
  currentTabAllScore: state[REDUCER_NAME].currentTabAllScore,
  sortState: state[REDUCER_NAME].allScoreSortState,
});

const mapDispatchToProps = {
  loadMoreAllScore,
  changeIndustryTableDropDown,
  intervalFetchAllScore,
  changeAllScoreSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FiinTradeAllScoreTable);
